import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-payment-range',
  templateUrl: './payment-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PaymentRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
